import {
    trigger,
    state,
    animate,
    transition,
    style
} from '@angular/animations';

export const fadeInOutAnimation = trigger('fadeInOutAnim', [
    state('initial', style({ opacity: '0' })),
    state('final', style({ opacity: '1' })),
    transition('initial=>final', animate('0.5s ease-in-out')),
    transition('final=>initial', animate('0.5s ease-in-out'))
]);
